export const SectionLabel: React.FC<{ label: string; optional?: boolean }> = ({ label, optional }) => (
  <p className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-2">
    {label}
    {optional && <span className="text-indigo-500 dark:text-indigo-400 font-medium ml-1">(Optional)</span>}
  </p>
);

export const CharCount: React.FC<{ current: number; max: number; extra?: string }> = ({ current, max, extra }) => (
  <p className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500 mt-1">
    {current}/{max} Characters{extra && <span className="ml-3">{extra}</span>}
  </p>
);

export const Toggle: React.FC<{ checked: boolean; onChange: (v: boolean) => void }> = ({ checked, onChange }) => (
  <button
    type="button" role="switch" aria-checked={checked}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex w-10 h-5 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 ${checked ? 'bg-green-500' : 'bg-gray-200 dark:bg-gray-700'}`}
  >
    <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-transform duration-200 ${checked ? 'translate-x-5' : 'translate-x-0'}`} />
  </button>
);
